if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.cartNotification = document.getElementById('cart-notification');
      this.cartNotificationItem = document.getElementById('cart-notification-item');
      this.multi_item_request = false;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay').classList.remove('hidden');

      // Upsell items handled only in JS
      const upsell_ids_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-id`);
      const upsell_quantities_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-quantity`);
      let upsell_items = [];

      if (upsell_ids_nodes.length !== 0) {
        const upsell_ids = Array.from(upsell_ids_nodes).map(input => parseInt(input.value));
        const upsell_quantities = Array.from(upsell_quantities_nodes).map(input => parseInt(input.value));
        upsell_items = upsell_ids.map((id, index) => ({'id': id,'quantity': upsell_quantities[index]})).filter(item => item.quantity !== 0);
      }

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        }
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      // Samplebox payloads must be internally consistent (the cart
      // transform prices whatever id list it gets at the FULL box price).
      // On any mismatch: abort the add, never guess.
      if (!this.reconcileSampleboxProperties(formData)) {
        const builder = document.querySelector(`samplebox-builder[data-form-id="${this.form.getAttribute('id')}"]`);
        this.handleErrorMessage((builder && builder.dataset.errorIncomplete) || 'Selection incomplete');
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay').classList.add('hidden');
        return;
      }

      // Safety net for order increments: snap the submitted quantity to the
      // step of this form's quantity input (covers AddMultiplier and any
      // path that bypasses the quantity-input element's own snapping).
      this.snapQuantityToIncrement(formData);

      // If upsell items added refactor FormData
      if (upsell_items.length > 0) {
        this.multi_item_request = true;
        const items = upsell_items;
        const id = parseInt(formData.get('id'));
        const quantity = parseInt(formData.get('quantity')) || 1;
        const the_product_item = { 'id': id, 'quantity': quantity }

        // Rebuilding the payload as JSON items must not drop the form's
        // line-item properties (samplebox boxes are unfulfillable without
        // their Product N / _samplebox properties).
        const item_properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') item_properties[match[1]] = value;
        }
        if (Object.keys(item_properties).length > 0) the_product_item.properties = item_properties;

        items.push(the_product_item);
        const itemsData = { 'items': items };

        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(itemsData);
      } else {
        this.multi_item_request = false;
        config.body = formData;
      }

      try {
        const res = await fetch(routes.cart_add_url + '.js', config)
        const json = await res.json();

        if (res.status !== 200) throw new Error(json.description);

        if (this.cartNotification) {
          const notificationTemplate = document.importNode(this.cartNotification.content, true);

          if (this.multi_item_request) {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemsAdded;
            let lastElement = json.items.pop();
            json.items.unshift(lastElement);

            json.items.forEach(item => {
              const singleItem = this.createNotificationItem(item);
              notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
            });
          } else {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemAdded;
            const singleItem = this.createNotificationItem(json);
            notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
          }

          if (document.querySelector('.cart-notification')) {
            document.querySelector('.cart-notification').remove();
          }

          document.body.appendChild(notificationTemplate);

          const the_notification = document.querySelector('.cart-notification');

          // Set focus to the notification for accessibility
          the_notification.setAttribute('tabindex', '-1');
          the_notification.focus();

          the_notification.querySelector('.notification-close').addEventListener('click', () => {
            the_notification.classList.remove('anim-in');
          });
          setTimeout(() => {
            the_notification.classList.add('anim-in');
          }, 50);
        }

        const event = new CustomEvent('ajaxProduct:added')
        document.dispatchEvent(event)
      } catch(error) {
        this.handleErrorMessage(error);
        console.error(error);
      }

      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay').classList.add('hidden');
      this.resetQuantityInput();
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || document.querySelector(`.product-form__error-message-wrapper[form="${this.form.getAttribute('id')}"]`)
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    resetQuantityInput() {
      const formId = this.form.getAttribute('id');
      const hidden_quantity_input = document.querySelector(`[type=hidden][name=quantity][form="${formId}"]`) || this.form.querySelector('[type=hidden][name=quantity]');
      if (hidden_quantity_input) {
        // Reset to the server-rendered initial value (the order increment), not a hard-coded 1
        hidden_quantity_input.value = hidden_quantity_input.getAttribute('value') || hidden_quantity_input.min || 1;
      }
    }

    // Round the outgoing quantity to the nearest multiple of the order
    // increment carried by this form's quantity input (step attribute).
    snapQuantityToIncrement(formData) {
      const quantity = parseInt(formData.get('quantity'), 10);
      if (!Number.isFinite(quantity)) return;

      const formId = this.form.getAttribute('id');
      const input = document.querySelector(`[name="quantity"][form="${formId}"]`) || this.form.querySelector('[name="quantity"]');
      if (!input) return;

      const step = parseInt(input.step, 10) || 1;
      if (step <= 1) return;
      const min = parseInt(input.min, 10) || step;
      const snapped = Math.max(min, Math.round(quantity / step) * step);
      if (snapped !== quantity) formData.set('quantity', snapped);
    }

    // The samplebox builder submits visible properties[Product 1..N]
    // (names for the warehouse) plus a hidden properties[_samplebox] id
    // list that the cart transform function expands into real component
    // lines priced at the box's tier price. An id list shorter than the
    // submitted tier's slot count would still be expanded at the FULL box
    // price (silent overcharge), so the payload must be internally
    // consistent. The slot count is derived from the submitted variant id
    // — the payload's single source of truth — NOT from the "Aantal"
    // radio, which updates before the rest of the page catches up (and is
    // page-global, so another section's picker could be read). Stale
    // higher slots (container desync, e.g. bfcache form restore) are
    // pruned; any remaining inconsistency returns false, which aborts
    // the add — guessing here can only corrupt money.
    reconcileSampleboxProperties(formData) {
      const builder = document.querySelector(`samplebox-builder[data-form-id="${this.form.getAttribute('id')}"]`);
      if (!builder) return true; // not a samplebox form

      const container = builder.querySelector(`[data-samplebox-variant="${formData.get('id')}"]`);
      if (!container) return false;
      const count = container.querySelectorAll('select').length;
      if (count < 1) return false;

      let maxSlot = 0;
      for (const key of formData.keys()) {
        const match = key.match(/^properties\[Product\s+(\d+)\]$/);
        if (match) maxSlot = Math.max(maxSlot, parseInt(match[1], 10));
      }
      for (let slot = count + 1; slot <= maxSlot; slot++) {
        formData.delete(`properties[Product ${slot}]`);
      }

      for (let slot = 1; slot <= count; slot++) {
        if (!formData.get(`properties[Product ${slot}]`)) return false;
      }

      const ids = String(formData.get('properties[_samplebox]') || '').split(',').filter(Boolean);
      return ids.length === count;
    }

    createNotificationItem(product) {
      const notificationItemTemplate = document.importNode(this.cartNotificationItem.content, true);

      const filename = product.image.split('/').pop();
      const lastDotIndex = filename.lastIndexOf('.');
      const newFilename = `${filename.substring(0, lastDotIndex)}_120x${filename.substring(lastDotIndex)}`;
      const url = product.image.replace(filename, newFilename);

      notificationItemTemplate.querySelector('.notification-item-image').setAttribute('src', url);
      notificationItemTemplate.querySelector('.notification-item-image').classList.remove('hide');
      notificationItemTemplate.querySelector('.notification-item-title').textContent = product.product_title;

      product.options_with_values.forEach(item => {
        const row = document.createElement("dl");
        const nameCell = document.createElement("dt");
        const valueCell = document.createElement("dd");

        nameCell.textContent = item.name + ': ';
        valueCell.textContent = item.value;

        row.appendChild(nameCell);
        row.appendChild(valueCell);
        notificationItemTemplate.querySelector('.notification-item-details').appendChild(row);
      })

      const propertyKeyValues = Object.entries(product.properties);
      if (propertyKeyValues.length > 0) {
        const properties = document.createElement("dl");
        propertyKeyValues.forEach(([key, value]) => {
          const startsWith = key.startsWith('_');
          if (startsWith) return;
          const row = document.createElement("dl");
          const nameCell = document.createElement("dt");
          const valueCell = document.createElement("dd");

          nameCell.textContent = key + ': ';
          valueCell.textContent = value;

          row.appendChild(nameCell);
          row.appendChild(valueCell);
          properties.appendChild(row);
        });
        notificationItemTemplate.querySelector('.notification-item-details').appendChild(properties);
      }

      return notificationItemTemplate;
    }
  });
}

class AddMultiplier extends HTMLElement {
  constructor() {
    super();

    const multiplyButton = this.querySelector('button');
    this.submitEvent = new SubmitEvent("submit", { submitter: multiplyButton });
    this.multiplyBy = parseInt(this.querySelector('[name=multiplied-quantity]').value);
    this.productForm = this.closest('product-form').querySelector('form');
    const formId = this.productForm.getAttribute('id');
    this.quantity_input = document.querySelector(`[name=quantity][form=${ formId }]`);
    multiplyButton.addEventListener('click', this.submitProductForm.bind(this));
  }

  submitProductForm() {
    this.quantity_input.value = this.multiplyBy;
    this.productForm.dispatchEvent(this.submitEvent);
  }
}
customElements.define("add-multiplier", AddMultiplier);